<template>
  <div class="first-month-promotion">
    <h1 class="title" v-html="title"></h1>
    <p class="description" v-html="description"></p>
    <div class="table">
      <dl>
        <dt>1개월 차</dt>
        <dd>{{ price }}원</dd>
      </dl>
      <dl class="promotion-target">
        <dt>2개월 차</dt>
        <dd>100원</dd>
      </dl>
      <dl>
        <dt>3개월 차 이후</dt>
        <dd>{{ price }}원</dd>
      </dl>
    </div>
    <ul class="notice">
      <li v-for="notice in noticeList" :key="notice">{{ notice }}</li>
    </ul>
    <div class="button-area">
      <button
        type="button"
        class="button button-primary"
        @click="onClickProcess"
      >
        2개월 차 100원 혜택 받기
      </button>
      <button
        type="button"
        class="button button-gray"
        @click="onClickNoneEvent"
      >
        2개월 차 {{ price }}원 결제
      </button>
    </div>
  </div>
</template>
<script setup>
  import { defineProps, computed } from 'vue'
  import { getTextBreaks } from '@/common/util/string-manipulation/get-text-breaks'
  import { EventBus } from '@/components/eventbus/EventBus'
  import { FIRST_MONTH_PROMOTION_CONFIRM } from '@/common/resources/const'
  import { PROMOTION_100_VOUCHER } from '@/common/util/voucher/const'
  import { setNumberComma } from '@/common/util/set-number-comma'
  import { getReplacedPromotionProduct } from '@/common/util/voucher/get-replaced-promotion-product'

  const props = defineProps({
    payloads: {
      type: Object,
      default: () => ({}),
    },
  })

  const title = getTextBreaks(PROMOTION_100_VOUCHER.TITLE)
  const description = getTextBreaks(PROMOTION_100_VOUCHER.DESCRIPTIONS)
  const noticeList = PROMOTION_100_VOUCHER.NOTICES

  const voucherInfo = computed(() => props.payloads?.voucherInfo ?? {})
  const price = computed(
    () => setNumberComma(voucherInfo.value?.productInfo?.amount) ?? '',
  )

  const succeed = (payloads) => {
    EventBus.$emit(FIRST_MONTH_PROMOTION_CONFIRM, {
      isSuccess: true,
      payloads,
    })
  }

  const onClickProcess = () => {
    succeed(props.payloads)
  }

  const onClickNoneEvent = () => {
    const isOriginalPriceSelected = window.confirm(
      `2개월 차에 100원이 아닌 ${price.value}으로 결제됩니다. 계속하시겠습니까?`,
    )

    if (isOriginalPriceSelected) {
      const payloads = getReplacedPromotionProduct(props.payloads)

      succeed(payloads)
    }
  }
</script>
<style scoped lang="scss">
  .first-month-promotion {
    padding: 24px 12px 12px 12px;
    overflow-y: auto;
    .title {
      color: #fff;
      font-size: 20px;
      font-weight: 400;
      line-height: 1.4;
      text-align: center;
    }
    .description {
      margin-top: 40px;
      color: #fff;
      font-size: 14px;
      line-height: 1.42;
      text-align: center;
    }
    .table {
      margin-top: 20px;
      dl {
        padding: 20px;
        border: 1px solid #2f2f2f;
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        dt {
          color: #a5a5a5;
          font-size: 12px;
          line-height: 1.5;
        }
        dd {
          color: #a5a5a5;
          font-size: 16px;
          font-weight: 400;
          line-height: 1.5;
        }
        & + dl {
          margin-top: 8px;
        }
        &.promotion-target {
          border-color: #a5a5a5;
          dt {
            color: #fff;
          }
          dd {
            color: #fff;
            font-size: 16px;
            font-weight: 700;
            line-height: 1.5;
          }
        }
      }
    }
    .notice {
      margin-top: 20px;
      padding-bottom: 196px;
      font-size: 12px;
      line-height: 1.5;
      font-weight: 400;
      color: #5e5e5e;
      > li {
        position: relative;
        padding-left: 6px;
        &:before {
          content: '';
          position: absolute;
          top: 8px;
          left: 0;
          width: 2px;
          height: 2px;
          background-color: #5e5e5e;
          border-radius: 50%;
        }
        & + li {
          margin-top: 4px;
        }
      }
    }
    .button-area {
      position: fixed;
      bottom: 0;
      left: 50%;
      width: 100%;
      transform: translate(-50%, 0);
      padding: 0 12px 28px 12px;
      background-color: #1b1b1b;
      [class^='button'] {
        display: block;
        width: 100%;
        padding: 12px 0;
        border-radius: 30px;
        font-weight: 400;
        font-size: 16px;
        line-height: 1.5;
        color: #fff;
        & + .button {
          margin-top: 8px;
        }
      }
      .button-primary {
        background-color: #0050ff;
      }
      .button-gray {
        background-color: #2f2f2f;
      }
    }
  }
</style>
